import { connect } from 'react-redux';
import { Map } from 'immutable';

import decorate from '../../utils/decorate';

import { request as createRequest } from '../../modules/staff/actions/create';

import CreateUserModal from './CreateUserModal.jsx';

const STATE_KEY = 'create-user-modal';

function mapStateToProps(state, props) {
    return {
        roles: state.roles.getIn([ 'items' ], Map()).filter(role => (
            state.roles.getIn([ 'collections', 'staff' ]).contains(role.get('id'))
        ))
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        onCreateUserRequest: userData => dispatch(createRequest(userData))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    CreateUserModal
);
